import {TextFieldProps} from '@mui/material'
import {FormikContextType} from 'formik'
import {get} from 'lodash'
import {useCallback} from 'react'

export interface UseFormikTextFieldHelpersOptions {
  translationObjectPath?: string
}

interface UseFormikTextFieldHelpersGetFieldPropsOptions {
  noTranslation?: boolean
}

export const useFormikTextFieldHelpers = (
  formik: FormikContextType<any>,
  {translationObjectPath}: UseFormikTextFieldHelpersOptions = {}
) => {
  const getFieldProps = useCallback(
    (field: string, options?: UseFormikTextFieldHelpersGetFieldPropsOptions): TextFieldProps => {
      const fieldName =
        !options?.noTranslation && translationObjectPath
          ? `${translationObjectPath}.${field}`
          : field
      return {
        ...formik.getFieldProps(fieldName),
        value: get(formik.values, fieldName) ?? '',
        error: !!get(formik.errors, fieldName) && (get(formik.touched, fieldName) as boolean),
        helperText:
          (get(formik.touched, fieldName) && (get(formik.errors, fieldName) as string)) || ' ',
      }
    },
    [formik, translationObjectPath]
  )

  return {getFieldProps}
}
